module.exports = __webpack_public_path__ + "img/logo-header.f5a3b250.png";